export default __webpack_public_path__ + "static/media/heatingFr.135d510a.jpg";